const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  CustomerToken: state => state.user.CustomerToken,
  UserObj: state => state.user.UserObj,
  ImgPath: state => state.user.ImgPath,
  roles: state => state.user.roles
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js